import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService, UserManagementService } from 'src/app/services/index';

@Component({
  selector: 'app-feature-selection-modal',
  templateUrl: './feature-selection-modal.component.html',
  styleUrls: ['./feature-selection-modal.component.scss']
})
export class FeatureSelectionModalComponent implements OnInit, AfterViewInit {
  @ViewChild('formDirective') formDirective: FormGroupDirective;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  formData: UntypedFormGroup;
  countSelected: number;
  model: any;
  roleFeatures: any;
  features: any;
  allActivities: any;
  roles = [
    { name: 'Admin Role', value: 1 },
    { name: 'Solar Role', value: 2 },
    { name: 'Engergy Role', value: 3 }
  ];
  modificationType = [
    { name: 'All', value: 1 },
    { name: 'View', value: 2 },
    { name: 'Add/Edit', value: 3 },
    { name: 'Delete', value: 4 }
  ];
  public user: any;
  users: any;
  selectedFeatures: any;
  featuresByUser: any;
  displayedColumns = ['index', 'selected', 'modificationType', 'featureName'];
  featuresDataSource: MatTableDataSource<any>;
  filterValues = {
    modificationTypeString: '',
    name: ''
  };
  featureNameSearch = '';
  constructor(
    private dialogRef: MatDialogRef<FeatureSelectionModalComponent>,
    private fb: UntypedFormBuilder,
    private userManagementService: UserManagementService,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      displayCtr: [],
      userCtr: [''],
      modificationTypeCtr: []
    });

    this.model = {
      applyUserName: '',
      displayAll: false,
      selectedModificationType: 1
    };
    this.selectedFeatures = this.user.activities;
    const roleId = this.user.role.roleId.replace('#', '');
    this.userManagementService.getUserListByRole(roleId).subscribe((data) => {
      if (data && data.length > 0) {
        this.users = data;
      }
    });
    this.userManagementService.getAllActivities().subscribe((data) => {
      if (data && data.data.length > 0) {
        this.allActivities = data.data;
      }
    });
    this.userManagementService.getFeatureOfRole(roleId).subscribe((data) => {
      if (data && data.data.length > 0) {
        this.featuresByUser = data.data;
      }
    });
    this.userManagementService.getroleWithActivities().subscribe((data) => {
      if (data && data.data.length > 0) {
        const allRoles = data.data;
        const findRole = allRoles.find(
          (c) => c.roleId === this.user.role.roleId
        );
        if (!this.commonService.isNullOrUndefined(findRole)) {
          this.roleFeatures = findRole.activities;
          this.features = findRole.activities;
          if (
            !this.commonService.isNullOrUndefined(this.user.activities) &&
            this.user.activities.length > 0
          ) {
            this.features.forEach((element) => {
              const feature = this.user.activities.find(
                (c) => c.activityId === element.activityId
              );
              if (!this.commonService.isNullOrUndefined(feature)) {
                element.selected = true;
              }
            });
          } else {
            this.selectAll();
          }
        }
        this.BindDataTable();
      }
    });
  }
  ngAfterViewInit() {
    // this.featuresDataSource.paginator = this.paginator;
  }
  BindDataTable() {
    this.featuresDataSource = new MatTableDataSource<any>(this.features);
    this.featuresDataSource.paginator = this.paginator;
    this.featuresDataSource.filterPredicate = this.createFilter();
    this.selectedFeatures = this.featuresDataSource.data.filter(
      (x) => x.selected === true
    );
    this.countSelected = this.featuresDataSource.data.filter(
      (x) => x.selected === true
    ).length;
  }

  onDisplayCheckChange(evt) {
    if (evt.checked) {
      this.features = this.allActivities;
      this.features.forEach((feature: any) => {
        const find = this.roleFeatures.find(
          (c) => c.activityId === feature.activityId
        );
        if (!this.commonService.isNullOrUndefined(find)) {
          feature.selected = true;
        }
      });
    } else {
      this.features = this.roleFeatures;
    }
    this.BindDataTable();
  }
  onChangeFeature() {
    this.selectedFeatures = this.featuresDataSource.data.filter(
      (x) => x.selected === true
    );
    this.countSelected = this.featuresDataSource.data.filter(
      (x) => x.selected === true
    ).length;
  }
  // userSelectionChange() {
  //   const t = this.model.applyUserName;
  // }
  apply() {
    this.selectedFeatures = this.featuresByUser;
    this.features = this.featuresByUser;
    this.features.forEach((element) => {
      element.selected = true;
    });
    this.BindDataTable();
  }
  selectAll() {
    this.features.forEach((element) => {
      element.selected = true;
    });
  }
  public search = (term: string) => {
    let temp = '';
    if (term.length > 0) {
      temp = term.trim().toLowerCase();
    }
    this.featureNameSearch = temp;
    this.filterValues.name = temp;
    this.featuresDataSource.filter = JSON.stringify(this.filterValues);
  };
  public onModificationTypeChange = () => {
    if (this.commonService.isNullOrUndefined(this.featuresDataSource)) {
      return;
    }
    this.filterValues.name = this.featureNameSearch;
    if (this.model.selectedModificationType === 1) {
      this.filterValues.modificationTypeString = '';
    } else {
      this.filterValues.modificationTypeString = this.modificationType
        .filter((x) => x.value === this.model.selectedModificationType)
        .map((y) => y.name)[0];
      this.filterValues.modificationTypeString =
        !this.commonService.isNullOrUndefined(
          this.filterValues.modificationTypeString
        ) && this.filterValues.modificationTypeString !== ''
          ? this.filterValues.modificationTypeString.toLowerCase()
          : this.filterValues.modificationTypeString;
    }
    this.featuresDataSource.filter = JSON.stringify(this.filterValues);
  };
  createFilter(): (data: any, filter: string) => boolean {
    const filterFunction = (data: any, filter: any): boolean => {
      const searchTerms = JSON.parse(filter);

      return (
        data.modificationTypeString
          .toLowerCase()
          .includes(searchTerms.modificationTypeString) &&
        data.name.toString().toLowerCase().includes(searchTerms.name)
      );
    };
    return filterFunction;
  }
  public reset = (event: any) => {
    event.preventDefault();
    this.formDirective.resetForm();
    this.formData.reset();
  };
  save() {
    this.close(true);
  }
  close(confirm: boolean) {
    this.dialogRef.close({
      status: confirm,
      data: {
        countSelected: this.countSelected,
        selectedFeatures: this.selectedFeatures
      }
    });
  }
}
